import { camelCase, startCase } from 'lodash'
import FormCheckBox from 'app/components/form/FormCheckBox'
import type { CustomQuestionType, LocationJson } from 'app/types/entities'

export function SchedulingSmsConsentField({
  location,
  question,
}: {
  location?: LocationJson
  question: CustomQuestionType
}) {
  const fieldName = question.fieldName || `optIn_${question.id}`
  const inputName = camelCase(fieldName)
  const label = question.fieldName ? startCase(question.fieldName) : `SMS Consent`
  const descriptionId = `${inputName}-description`

  return (
    <div className="col-span-12 md:col-span-6">
      <FormCheckBox
        name={inputName}
        label={label}
        labelClassName={`text-default text-ui-sm ${question.required ? `required` : ``}`}
        required={question.required}
        aria-describedby={descriptionId}
      />
      <div id={descriptionId} className="ml-6 mt-2 w-11/12 text-sm leading-5 text-subtle">
        <span>{question.description || `I agree to receive text messages.`}</span>{' '}
        <span>
          Message frequency varies. Message and data rates may apply. Reply STOP to unsubscribe or HELP for help.
        </span>{' '}
        {location?.id && (
          <span>
            View the{' '}
            <a
              className="font-medium text-blue-700 underline"
              href={`/scheduling/${location.id}/sms-terms`}
              target="_blank"
              rel="noreferrer"
            >
              SMS Terms
            </a>{' '}
            and{' '}
            <a
              className="font-medium text-blue-700 underline"
              href={`/scheduling/${location.id}/sms-privacy`}
              target="_blank"
              rel="noreferrer"
            >
              SMS Privacy Policy
            </a>
            .
          </span>
        )}
      </div>
    </div>
  )
}
